{
  "list": {
    "title": "Khách hàng",
    "subtitle": "Quản lý khách hàng (phụ huynh / học viên tự trả phí).",
    "add": "Thêm khách hàng",
    "search": "Tìm khách (tên, email, điện thoại, tag)...",
    "filterByTag": "Lọc theo tag",
    "clearFilter": "Xoá bộ lọc",
    "noResults": "Không tìm thấy khách phù hợp.",
    "name": "Tên",
    "email": "Email",
    "zaloPhone": "Zalo / SĐT",
    "added": "Ngày thêm",
    "outstanding": "Còn nợ",
    "actions": "Hành động",
    "loading": "Đang tải...",
    "empty": "Chưa có khách hàng. Thêm khách hàng đầu tiên để bắt đầu.",
    "view": "Xem",
    "sortNewest": "Mới nhất",
    "sortOldest": "Cũ nhất",
    "sortName": "Tên A→Z",
    "prev": "Trước",
    "next": "Sau",
    "pageOf": "Trang {{page}}/{{pages}} · {{total}} khách hàng"
  },
  "create": {
    "title": "Thêm khách hàng",
    "description": "Nhập thông tin khách hàng. Tên là bắt buộc.",
    "name": "Tên *",
    "namePlaceholder": "Công ty ABC",
    "email": "Email",
    "emailPlaceholder": "lienhe@abc.com",
    "zaloPhone": "Zalo / SĐT",
    "zaloPhonePlaceholder": "0901234567",
    "dupPayerWarning": "SĐT này đã có người trả phí {{name}}, dùng lại?",
    "cancel": "Huỷ",
    "submit": "Lưu khách hàng",
    "submitting": "Đang lưu..."
  },
  "detail": {
    "notFound": "Không tìm thấy khách hàng",
    "backToList": "Quay lại",
    "delete": "Xoá khách hàng",
    "deleteConfirm": "Bạn chắc chắn muốn xoá khách hàng này? Hoá đơn của khách hàng sẽ vẫn được giữ lại.",
    "identityBadge": "Khách hàng · phụ huynh",
    "createInvoice": "Tạo hoá đơn",
    "edit": "Sửa",
    "tabsLabel": "Nội dung khách hàng",
    "added": "Thêm {{date}}",
    "phoneZalo": "{{phone}} (Zalo)",
    "emptyStudentsTitle": "Chưa có học viên nào",
    "emptyStudentsBody": "Thêm học viên và chọn {{name}} làm người trả phí.",
    "emptyStudentsCta": "Thêm học viên",
    "tabs": {
      "students": "Học viên",
      "invoices": "Hoá đơn",
      "notes": "Ghi chú",
      "activity": "Hoạt động",
      "info": "Thông tin"
    },
    "stats": {
      "invoiceCount": "Hoá đơn",
      "revenue": "Doanh thu",
      "unpaid": "Còn nợ",
      "overdue": "Quá hạn"
    }
  },
  "tags": {
    "label": "Tag",
    "addTag": "Thêm thẻ phân loại",
    "addPlaceholder": "Nhập tên tag...",
    "moreCount": "+{{count}}"
  },
  "invoices": {
    "code": "Hoá đơn",
    "amount": "Số tiền",
    "status": "Trạng thái",
    "due": "Hạn",
    "empty": "Chưa có hoá đơn cho khách này",
    "createFirst": "Tạo hoá đơn",
    "emptyBody": "Tạo hoá đơn lẻ cho khách này, hoặc chờ Chốt sổ tháng tạo tự động."
  },
  "notes": {
    "addPlaceholder": "Thêm ghi chú về khách...",
    "save": "Lưu",
    "saving": "Đang lưu...",
    "edit": "Sửa",
    "delete": "Xoá",
    "cancel": "Huỷ",
    "deleteConfirm": "Xoá ghi chú này?",
    "showingRecent": "Hiển thị 50 ghi chú gần nhất",
    "emptyTitle": "Chưa có ghi chú",
    "emptyBody": "Ghi lại thoả thuận học phí, lịch nghỉ… để cả tổ chức cùng thấy."
  },
  "activity": {
    "invoiceCreated": "Đã tạo hoá đơn {{code}} trị giá {{amount}}",
    "invoiceSent": "Đã gửi hoá đơn {{code}} qua email",
    "invoiceSentZalo": "Đã gửi hoá đơn {{code}} qua Zalo",
    "invoicePaid": "Hoá đơn {{code}} đã được thanh toán {{amount}}",
    "invoiceOverdue": "Hoá đơn {{code}} đã quá hạn",
    "invoiceCancelled": "Đã huỷ hoá đơn {{code}}",
    "invoiceViewed": "Khách đã xem hoá đơn {{code}}",
    "reminderSent": "Đã gửi nhắc hoá đơn {{code}}",
    "noteAdded": "Đã thêm ghi chú: \"{{preview}}\"",
    "noteEdited": "Đã chỉnh sửa ghi chú",
    "tagAdded": "Đã thêm tag {{tag}}",
    "tagRemoved": "Đã xoá tag {{tag}}",
    "infoUpdated": "Đã cập nhật {{field}} từ {{oldValue}} → {{newValue}}",
    "loadMore": "Tải thêm",
    "loading": "Đang tải...",
    "empty": "Chưa có hoạt động nào."
  },
  "fields": {
    "name": "tên",
    "email": "email",
    "zaloPhone": "số điện thoại"
  },
  "info": {
    "title": "Thông tin khách hàng",
    "name": "Tên khách hàng",
    "email": "Email",
    "zaloPhone": "Số điện thoại / Zalo",
    "save": "Lưu thay đổi",
    "saving": "Đang lưu...",
    "cancel": "Huỷ"
  }
}
